import { configureStore } from '@reduxjs/toolkit';
import customMiddleware from './middleware';
import monitorReducersEnhancer from './enhancers/monitorReducers';
import loggerMiddleware from './middleware/logger';
import rootReducer from './reducer';
import { persistStore } from 'redux-persist';

// Create an array of middlewares
const middlewares = [customMiddleware];

if (import.meta.env.NODE_ENV !== 'production') {
  middlewares.push(loggerMiddleware);
}

export function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middlewares),
    devTools: import.meta.env.NODE_ENV !== 'production',
    preloadedState,
    enhancers: (getDefaultEnhancers)=> getDefaultEnhancers().concat([monitorReducersEnhancer]),
  });
  const persistor = persistStore(store);
  return { store, persistor };
}
